import { Person } from "@/Common/Models/Person/Person";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { MyAPSSFormTableItem } from "@/Portfolio/Models/MyNotesInboxTableItem";

type GlobalPortfolioSearchText = "GlobalPortfolioSearchText";
type TableData = "TableData";

type SelectedPageSizeOption = "SelectedPageSizeOption";
type TotalQueryRows = "TotalQueryRows";
type CurrentPage = "CurrentPage";

type ColumnOrderingPopupOpen = "ColumnOrderingPopupOpen";
type ShowSettings = "ShowSettings";

type SelectedEmployee = "SelectedEmployee";
type FilterType = "FilterType";
type PageSizeOptions = "PageSizeOptions";

type StatusFilter = "StatusFilter";
type ShowPrerequisManquant = "ShowPrerequisManquant";

type ExpandPrerequis = "ExpandPrerequis";

type DateTo = "DateTo";
type DateFrom = "DateFrom";

type GeneratedFileName = "GeneratedFileName";

type ConseilNumeriqueTableData = "ConseilNumeriqueTableData";

type ConseilNumeriqueSelectedPageSizeOption = "ConseilNumeriqueSelectedPageSizeOption";
type ConseilNumeriqueTotalQueryRows = "ConseilNumeriqueTotalQueryRows";
type ConseilNumeriqueCurrentPage = "ConseilNumeriqueCurrentPage";
type ShowArchivedConseilNumerique = "ShowArchivedConseilNumerique";
type ConseilNumeriqueFilterType = "ConseilNumeriqueFilterType";
type ConseilNumeriqueSelectedEmployee = "ConseilNumeriqueSelectedEmployee";
type ConseilNumeriqueColumnOrderingPopupOpen = "ConseilNumeriqueColumnOrderingPopupOpen";

type ActionRequiredTableData = "ActionRequiredTableData";
type ActionRequiredTotalQueryRows = "ActionRequiredTotalQueryRows";
type ActionRequiredCurrentPage = "ActionRequiredCurrentPage";
type ActionRequiredSelectedPageSizeOption = "ActionRequiredSelectedPageSizeOption";
type ShowArchivedActionRequired = "ShowArchivedActionRequired";
type ActionRequiredSearchText = "ActionRequiredSearchText";
type ActionRequiredShowSettings = "ActionRequiredShowSettings";
type ActionRequiredFilterType = "ActionRequiredFilterType";
type ActionRequiredSelectedEmployee = "ActionRequiredSelectedEmployee";
type ActionRequiredExpandPrerequis = "ActionRequiredExpandPrerequis";

enum ApssFilterType {
    ParLicenceMDReferant,
    ParCreateur
}

interface IAPSSInboxModel {

    get(key: ExpandPrerequis): string;
    set(key: ExpandPrerequis, value: string): this;

    get(key: StatusFilter): Immutable.List<CheckboxUIModel>;
    set(key: StatusFilter, value: Immutable.List<CheckboxUIModel>): this;

    get(key: SelectedEmployee): Person;
    set(key: SelectedEmployee, value: Person): this;

    get(key: FilterType): ApssFilterType;
    set(key: FilterType, value: ApssFilterType): this;

    get(key: GlobalPortfolioSearchText): string;
    set(key: GlobalPortfolioSearchText, value: string): this;

    get(key: TableData): Immutable.List<MyAPSSFormTableItem>;
    set(key: TableData, value: Immutable.List<MyAPSSFormTableItem>): this;

    get(key: SelectedPageSizeOption): number;
    set(key: SelectedPageSizeOption, value: number): this;

    get(key: PageSizeOptions): Immutable.List<number>;
    set(key: PageSizeOptions, value: Immutable.List<number>): this;

    get(key: TotalQueryRows): number;
    set(key: TotalQueryRows, value: number): this;

    get(key: CurrentPage): number;
    set(key: CurrentPage, value: number): this;

    get(key: ColumnOrderingPopupOpen): boolean;
    set(key: ColumnOrderingPopupOpen, value: boolean): this;

    get(key: ShowSettings): boolean;
    set(key: ShowSettings, value: boolean): this;

    get(key: ShowPrerequisManquant): boolean;
    set(key: ShowPrerequisManquant, value: boolean): this;

    get(key: DateFrom): Date;
    set(key: DateFrom, value: boolean): this;

    get(key: DateTo): Date;
    set(key: DateTo, value: boolean): this;

    get(key: GeneratedFileName): string;
    set(key: GeneratedFileName, value: string): this;

    get(key: ConseilNumeriqueTableData): Immutable.List<MyAPSSFormTableItem>;
    set(key: ConseilNumeriqueTableData, value: Immutable.List<MyAPSSFormTableItem>): this;

    get(key: ConseilNumeriqueSelectedPageSizeOption): number;
    set(key: ConseilNumeriqueSelectedPageSizeOption, value: number): this;

    get(key: ConseilNumeriqueTotalQueryRows): number;
    set(key: ConseilNumeriqueTotalQueryRows, value: number): this;

    get(key: ConseilNumeriqueCurrentPage): number;
    set(key: ConseilNumeriqueCurrentPage, value: number): this;

    get(key: ConseilNumeriqueFilterType): ApssFilterType;
    set(key: ConseilNumeriqueFilterType, value: ApssFilterType): this;

    get(key: ConseilNumeriqueSelectedEmployee): Person;
    set(key: ConseilNumeriqueSelectedEmployee, value: Person): this;

    get(key: ConseilNumeriqueColumnOrderingPopupOpen): boolean;
    set(key: ConseilNumeriqueColumnOrderingPopupOpen, value: boolean): this;

    get(key: ShowArchivedConseilNumerique): boolean;
    set(key: ShowArchivedConseilNumerique, value: boolean): this;

    get(key: ActionRequiredTableData): Immutable.List<MyAPSSFormTableItem>;
    set(key: ActionRequiredTableData, value: Immutable.List<MyAPSSFormTableItem>): this;

    get(key: ActionRequiredTotalQueryRows): number;
    set(key: ActionRequiredTotalQueryRows, value: number): this;

    get(key: ActionRequiredCurrentPage): number;
    set(key: ActionRequiredCurrentPage, value: number): this;

    get(key: ActionRequiredSelectedPageSizeOption): number;
    set(key: ActionRequiredSelectedPageSizeOption, value: number): this;

    get(key: ShowArchivedActionRequired): boolean;
    set(key: ShowArchivedActionRequired, value: boolean): this;

    get(key: ActionRequiredSearchText): string;
    set(key: ActionRequiredSearchText, value: string): this;

    get(key: ActionRequiredShowSettings): boolean;
    set(key: ActionRequiredShowSettings, value: boolean): this;

    get(key: ActionRequiredFilterType): ApssFilterType;
    set(key: ActionRequiredFilterType, value: ApssFilterType): this;

    get(key: ActionRequiredSelectedEmployee): Person;
    set(key: ActionRequiredSelectedEmployee, value: Person): this;

    get(key: ActionRequiredExpandPrerequis): string;
    set(key: ActionRequiredExpandPrerequis, value: string): this;
}

export { ApssFilterType, IAPSSInboxModel };
